import { render, staticRenderFns } from "./DataCenterTableSb.vue?vue&type=template&id=1dc22227"
import script from "./DataCenterTableSb.vue?vue&type=script&lang=js"
export * from "./DataCenterTableSb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports